import React from "react"
import { FormattedMessage } from "react-intl"
import Icon from "../../common/icon/icon.component"
import { ImportStatusProps } from "../../common/types/inventory"

const ImportStatus=(props:ImportStatusProps)=>{
    if (!props.status) {
        return <></>
    }

    const details = {
        ["created"]: {
            icon: "hourglass-half",
            label: <FormattedMessage
                id="import.status.created"
                defaultMessage="Created"
            />,
            className: "badge-warning"
        },
        ["in-progress"]: {
            icon: "check",
            label: <FormattedMessage
                id="import.status.in.progress"
                defaultMessage="In-Progress"
            />,
            className: "badge-warning"
        },
        ["completed"]: {
            icon: "times",
            label: <FormattedMessage
                id="import.status.completed"
                defaultMessage="Completed"
            />,
            className: "badge-success"
        },    
        ["error"]: {
            icon: "times",
            label: <FormattedMessage
                id="import.status.error"
                defaultMessage="Error"
            />,
            className: "badge-danger"
        },   
    }

    return <div className={props.className + " badge badge-pill " + details[props.status].className}>
        <Icon className={"mr-1"} value={details[props.status].icon} />
        {details[props.status].label}
    </div>
    

}

export default ImportStatus


// WEBPACK FOOTER //
// ./src/product/import/Status.tsx